export default __webpack_public_path__ + "static/media/topHeader.53fa77e8.svg";